import React, {Component} from 'react';
import { Col, Row, Tabs,Tab,  FormControl} from 'react-bootstrap';
import FileDownload from 'shared/FileDownload';
import moment   from 'moment'
import config from  '../../../config';
import json2csv   from 'json2csv'


import Select   from 'react-select'
 import {prepareSelectOptionsList,filterFocusAreaOptions, filterFocusAreaSelectedOptions} from 'util/Utils';
 const allReportFieldList = [
     {label: 'First name', value:'firstName'},
     {label: 'Last name', value:'lastName'},
     {label: 'Email', value:'email'},
    {label: 'Shopify Customer ID', value:'ShopifyCustomerID'},
    {label: 'Newsletters', value:'Newsletters'},
    {label: 'Profile Image', value:'ProfileImage'},
    {label: 'Roles', value:'Roles'},
     {label: 'BA Street', value:'BillingAddress.Street'},
     {label: 'BA State', value:'BillingAddress.State'},
     {label: 'BA City', value:'BillingAddress.City'},
     {label: 'BA Zip', value:'BillingAddress.Zip'},
     {label: 'Shopify Customer Data', value:'ShopifyCustomerData'},
     {label: 'Create Date', value:'createdAt'},

]

export default class AdminUsersActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
             pending: false,
            reportFields: [
                {label: 'First name', value:'firstName'},
                {label: 'Last name', value:'lastName'},
                {label: 'Email', value:'email'},
                {label: 'Shopify Customer ID', value:'ShopifyCustomerID'},
                {label: 'Newsletters', value:'Newsletters'},
                {label: 'Profile Image', value:'ProfileImage'},
                {label: 'Roles', value:'Roles'},
                {label: 'BA Street', value:'BillingAddress.Street'},
                {label: 'BA State', value:'BillingAddress.State'},
                {label: 'BA City', value:'BillingAddress.City'},
                {label: 'BA Zip', value:'BillingAddress.Zip'},
                {label: 'Shopify Customer Data', value:'ShopifyCustomerData'},
                {label: 'Create Date', value:'createdAt'},
            ]
         };

    };




    downloadReport(){
         var methodData = {
            "endpoint": "/create-report",
            'type':'post',
             'not_display_success_message':true,
             overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
         this.props.makeRequest({'users': this.props.adminUsers.selectedUsers, reportType:'users' }, methodData).then(res => {
           var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
           })
             var csvData = json2csv.parse( res.data, {
                 fields: fields,
                 unwindPath: 'UserID'
             })

               var filename = "users_report" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
               var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
               if (navigator.msSaveBlob) { // IE 10+
                   navigator.msSaveBlob(blob, filename);
               } else {
                   var link = document.createElement("a");
                   if (link.download !== undefined) { // feature detection
                       // Browsers that support HTML5 download attribute
                       var url = URL.createObjectURL(blob);
                       link.setAttribute("href", url);
                       link.setAttribute("download", filename);
                       link.style.visibility = 'hidden';
                       document.body.appendChild(link);
                       link.click();
                       document.body.removeChild(link);
                   }
               }

        }).catch(err => {
            console.log('err', err );
        });
    }

    onSelectTab(event){
        this.setState({displayReportTab:!this.state.displayReportTab})
    }
    render() {

        // if (_.size(self.state.filterOptions.ageGroup) >0 ){
        //     ageRanges.unshift({value: false, label: 'All groups'});
        //  }
        return (
            <div className="action-block">

                <Tabs defaultActiveKey={''}  onSelect={(e)=>{this.onSelectTab(e)}} id="userActionBox" >

                    <Tab eventKey={'reports'} className={this.state.displayReportTab ? '' : 'hidden'}
                         unmountOnExit={true} title="Reports">
                        <Row className="show-grid">
                            <Col md={4} xs={4} className="top10">
                                <Select
                                    tabIndex="0"
                                    searchable={true}
                                    multi
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Included fields"
                                    options={allReportFieldList}
                                    onChange={ (selectedOptions) => this.setState({'reportFields': selectedOptions})}
                                    //  filterOptions={filterOptions}
                                    value={this.state.reportFields}
                                />
                            </Col>

                        </Row>
                        <Row>

                            <Col md={3} xs={6} className="top10">
                                <button className="btn btn-primary" disabled={this.state.pending}
                                        onClick={ this.downloadReport.bind(this)}
                                        type="button">
                                    Download report
                                </button>


                            </Col>
                        </Row>
                    </Tab>

                    </Tabs>

                </div >
        );

    }
}



